import moment from "moment";
import React from "react";
import { useNavigate } from "react-router-dom";
import AuthContext from "../../context/AuthContext";
import { useContextSelector } from "use-context-selector";
import LiveMatchTracker from "../Score/ScoreBoard";

const ListingSports = ({
  heading,
  data,
  showScore,
  handleScore,
  isSportTab,
  addToFavioute,
  activeFav,
}) => {
  const parlay = useContextSelector(AuthContext, (ctx) => {
    return ctx.parlay;
  });
  function isDateToday(date) {
    return moment(date).isSame(moment(), "day");
  }
  const navigate = useNavigate();
  const displayScore = ({ object }) => {
    return <iframe
        style={{ width: "100%", height: "270px" }}
        src={object?.scoreUrl}
      />
    
  };
  return (
    <div className="mb-4">
      {isSportTab == "all" && (
        <div className="h-34px flex justify-start items-center bg-secondary">
          <span className="block ml-2 mr-11px w-3px h-16px rounded-1.5px bg-event-tab-icon" />
          <p className="text-15 font-bold text-event-tab-icon">{heading}</p>
        </div>
      )}
      <div className="vue-recycle-scroller ready page-mode direction-vertical">
        <div className="vue-recycle-scroller__slot" />
        <div
          className="vue-recycle-scroller__item-wrapper grid grid-cols-1 divide-y divide-black-100"
          //   style={{ "min-height": "462px" }}
        >
          {data?.map((res) => {
            let animate = activeFav?.includes(res?.eventId);
            return (
              <div
                onClick={() => {
                  if (parlay) {
                    navigate(
                      `/match-detail-velki/${res?.eventId}/${res?.marketId}/multi`
                    );
                  } else {
                    navigate(`/match-detail-velki/${res?.eventId}/${res?.marketId}`);
                  }
                }}
                className="vue-recycle-scroller__item-view"
                style={{
                  "-webkit-transform": "translateY(0px) translateX(0px)",
                  "-ms-transform": "translateY(0px) translateX(0px)",
                  transform: "translateY(0px) translateX(0px)",
                }}
              >
                <div data-index={0}>
                  <div
                    data-v-4ca41f3e
                    className="event-block-item-row grid justify-center items-center bg-white"
                  >
                    <div data-v-4ca41f3e>
                      <div
                        data-v-4ca41f3e
                        className="animed-star -ml-2px w-8 mr-1 sm:mx-1 flex justify-center items-center"
                      >
                        <i className="icon-star-solid relative pl-1 pt-0.25 text-15 text-black-300" />
                      </div>
                    </div>
                    <div
                      data-v-4ca41f3e
                      className="h-full flex justify-center items-start flex-col py-8px bg-white text-13 leading-17px"
                    >
                      <div data-v-4ca41f3e className="w-274px mb-px">
                        <p data-v-4ca41f3e className="truncate">
                          {res?.eventName}
                        </p>
                      </div>
                      <div className="flex gap-2px justify-start items-center">
                        <div className="flex justify-center items-center gap-2px">
                          {" "}
                          {res?.status == "in_play" && (
                            <div className="icon-live">
                              <img
                                src="/assets/images/live.svg"
                                alt="streaming"
                                className="h-10px"
                              />
                            </div>
                          )}
                          {res?.hasFancy && (
                            <div className="icon-fancybet">
                              <img
                                src="/assets/images/fancybet.svg"
                                alt="fancybet"
                                className="h-10px"
                              />
                            </div>
                          )}
                          {res?.hasBookmaker && (
                            <div className="icon-bookmaker">
                              <img
                                src="/assets/images/bookmaker.svg"
                                alt="bookmaker"
                                className="h-10px"
                              />
                            </div>
                          )}
                          {res?.hasSportBook && (
                            <div className="icon-sportsbook">
                              <img
                                src="/assets/images/sportsbook.svg"
                                alt="sportsbook"
                                className="h-10px"
                              />
                            </div>
                          )}
                        </div>
                        {res?.status == "in_play" ? (
                          <div
                            data-v-ef8204d4
                            className="inline-flex items-center h-full"
                            data-is-inplay-type="true"
                            data-is-today-type="false"
                            data-is-tomorrow-type="false"
                          >
                            <div data-v-ef8204d4 className>
                              <div
                                data-v-ef8204d4
                                className="px-3px flex items-center justify-center bg-inPlay text-white font-bold text-8 leading-9px"
                              >
                                <span data-v-ef8204d4 className="mt-1px">
                                  In-Play
                                </span>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div
                            data-v-ef8204d4
                            className="inline-flex items-center h-full"
                            data-is-inplay-type="false"
                            data-is-today-type="true"
                            data-is-tomorrow-type="false"
                          >
                            <div data-v-ef8204d4 className>
                              <div
                                data-v-ef8204d4
                                className="time-block flex items-center justify-center leading-9px"
                                data-is-today-type="true"
                                data-is-tomorrow-type="false"
                              >
                                <span
                                  data-v-ef8204d4
                                  className="text-submenu py-px text-center text-8 px-2px pb-0"
                                >
                                  {isDateToday(res?.eventDateTime)
                                    ? "Today"
                                    : moment(res?.eventDateTime).format(
                                        "DD/MM"
                                      )}{" "}
                                  {moment(res?.eventDateTime).format("HH:MM")}
                                </span>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        handleScore(res?.scoreId);
                      }}
                      data-v-4ca41f3e
                      className="flex justify-end items-center"
                    >
                      <i
                        data-v-4ca41f3e
                        className={`ml-7px text-14 ${
                          showScore?.includes(res?.scoreId)
                            ? "icon-h2h-soild"
                            : "icon-h2h"
                        } `}
                      />
                    </div>
                    <div
                      data-v-4ca41f3e
                      className="h-full flex justify-center items-center bg-white"
                    >
                      <span
                        data-v-4ca41f3e
                        className="icon-arrow-left transform rotate-180 text-12 text-black-500"
                      />
                    </div>
                  </div>
                  {showScore?.includes(res?.scoreId) && (
                    <div
                      style={{ position: "relative" }}
                      data-v-4ca41f3e
                      data-v-70c0486c
                      className="head-to-head-wrapper relative bg-LMT border-y border-black-100"
                    >
                      <div
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          handleScore(res?.scoreId);
                        }}
                        data-v-70c0486c
                        className="icon-close text-8 absolute top-7px right-5px z-10"
                      />
                      {displayScore({ object: res })}
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ListingSports;
